import "client-only";
import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

function useDetailBulkReturnProcessing(id) {
  return useSWR(
    id
      ? {
          path: `/api/v1/return-logs/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );
}

export default useDetailBulkReturnProcessing;
